export function getdata() {
	let obj ={
				maplist:[
					{
						value:null,
						item:'未采集'
					},
					{
						value:0,
						item:'未采集'
					},
					{
						value:1,
						item:'采集成功'
					},
					{
						value:2,
						item:'采集失败'
					},
					{
						value:3,
						item:'采集中'
					}
				],
				formlist: [{
						prop: "dq",
						label: "省市地区代码",
						isnotnull: true,
						type: "select",
						selectchange: true,
						selectval: [],
					},
					{
						prop: "dlfs",
						label: "登录方式",
						isnotnull: true,
						type: "select",
						selectchange: true,
					},
					{
						prop: "grdlfs",
						label: "个人登录方式",
						isnotnull: true,
						type: "select",
					},
		
					{
						prop: "dlzh",
						label: "账号",
						isnotnull: true,
						type: "input",
					},
					{
						prop: "dlmm",
						label: "密码",
						type: "input",
						ispassword: true,
						isnotnull: true,
					},
					{
						prop: "sflx",
						label: "身份类型",
						type: "select",
						isnotnull: true,
					},
					{
						prop: "zrrsfzh",
						label: "证件号码",
						type: "input",
						isnotnull: true,
					},
					{
						prop: "gryhm",
						label: "个人用户名",
						isnotnull: true,
						type: "input",
					},
					{
						prop: "gryhmm",
						label: "个人密码",
						isnotnull: true,
						type: "input",
						ispassword: true
					},
					{
						prop: "sjhm",
						label: "办税小号",
						type: "input",
						isnotnull: true,
					},
					{
						prop: "bssjhm",
						label: "办税手机号",
						type: "input",
						isnotnull: true,
					}
				],
				formdata: {
					dq: '',
					grdlfs: '1',
					dlfs: "",
					dlzh: '',
					dlmm: '',
					sflx: '',
					zrrsfzh: '',
					gryhm: '',
					gryhmm: '',
					sjhm: '',
					bssjhm: '',
				},
				ruleForm: {},
				rules: {
					companyCode: [{
						required: true,
						message: '请填写公司代码',
						trigger: 'blur'
					}],
					shifbszt: [{
						required: true,
						message: '请选择是否为报税主体',
						trigger: 'blur'
					}],
					nsrsbh: [{
						required: true,
						message: '请填写纳税人识别号',
						trigger: 'blur'
					}],
					test4: [{
						required: true,
						message: '请选择是否启用',
						trigger: 'blur'
					}],
					test5: [{
						required: true,
						message: '请填写纳税人(公司)名称',
						trigger: 'blur'
					}],
					test6: [{
						message: '',
						trigger: 'blur'
					}],
					test7: [{
						message: '',
						trigger: 'blur'
					}],
					test8: [{
						message: '',
						trigger: 'blur'
					}],
					test9: [{
						message: '',
						trigger: 'blur'
					}],
					test10: [{
						message: '',
						trigger: 'blur'
					}],
					test11: [{
						message: '',
						trigger: 'blur'
					}],
					test12: [{
						message: '',
						trigger: 'blur'
					}],
					test13: [{
						message: '',
						trigger: 'blur'
					}],
					test14: [{
						message: '',
						trigger: 'blur'
					}],
					test15: [{
						message: '',
						trigger: 'blur'
					}],
					nsrmc: [{
						message: '请填写纳税人(公司)名称',
						trigger: 'blur'
					}]
				},
				headData: [{
						title: "公司代码",
						prop: "companyCode",
						align: "left"
					},
					{
						title: "公司名称",
						prop: "nsrmc",
						align: "left"
					},
					{
						title: "是否启用",
						prop: "sfyx",
						custom: true,
						align: "left"
					},
				],
				ruledata: {
		
				},
				tableData: '',
				rpaFormData: {
					loginPhone: "",
					loginEmail: "",
					loginPassword: "",
					province: "",
					contact: "",
					contactEmail: ""
				}
	}
	return obj 
}
